import { createFileRoute } from '@tanstack/react-router'
import { StaffKelembagaan } from '../../../../components/StaffKelembagaan'

export const Route = createFileRoute('/desa/$slug/dashboard/kelembagaan')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <StaffKelembagaan desaId={desaId} />
  },
})
